import React, { useState, useEffect } from 'react'
import { mediaQuery, capitalize } from '@cms/utils'

import { Translate } from 'gatsby-plugin-translate'

import * as S from './styled'
import getIcon from '../Icons'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion'

import { useProductDetailContext } from '../../../contexts'

const Prepare = () => {
  const { productDetail: product } = useProductDetailContext()

  const [expandedAccordion, setExpandedAccordion] = useState(true)

  const preExpandedAccordions = mediaQuery.isMedium() ? [] : ['preparo']

  const dataCurrentService = {
    exame: 'Agendamento de Exames | Exame',
    vacina: 'Agendamento de Vacinas | Vacina',
  }

  const excludedPreparationIds = [ 13, 16,31]

  const isValidPreparation = ({ descricao, tipoPreparo }) => {
    return (
      descricao &&
      !/Não se aplica/i.test(descricao) &&
      !/Not applicable/i.test(descricao) &&
      descricao.trim() !== '' &&
      !excludedPreparationIds.includes(tipoPreparo.id)
    )
  }

  const filteredPreparations = product.preparation?.filter(isValidPreparation) || []

  useEffect(() => {
    setExpandedAccordion(!preExpandedAccordions.length ? false : true)
  }, [])

  return (
    <Accordion
      allowZeroExpanded="true"
      preExpanded={preExpandedAccordions}
      onChange={() => setExpandedAccordion(expandedAccordion ? false : true)}
    >
      <AccordionItem
        uuid="preparo"
        data-item-text={`${expandedAccordion ? 'Fechar' : 'Abrir'} Preparo`}
        data-item-position="Informações de preparo"
        data-current-service={dataCurrentService[product.type]}
      >
        <AccordionItemHeading>
          <S.AccordionItemButtonCustom className="accordion-title">
            <Translate>Informações de preparo</Translate>
          </S.AccordionItemButtonCustom>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <S.PrepareContainer>
            {filteredPreparations.map(({tipoPreparo,descricao}, index) => (
              <S.PrepareItemContainer key={index}>
                <S.PrepareTypeIcon>{getIcon(tipoPreparo.codigoApi)}</S.PrepareTypeIcon>
                <S.PrepareTypeTitle>{capitalize(tipoPreparo.nome)}</S.PrepareTypeTitle>
                <S.PrepareTypeInfo>{descricao}</S.PrepareTypeInfo>
              </S.PrepareItemContainer>
            ))}
          </S.PrepareContainer>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default Prepare
